<template>
  <div>
    <footer class="footer">
      <div class="footer-bottom">
        <div class="container">
          <div class="inner">
            <div class="row">
              <div class="col-12">
                <div class="left">
                  <p>
                    Copyright &copy;
                    <router-link to="/">Tribinnov Africa</router-link
                    >&nbsp;<span>{{ currentYear }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <a href="#" class="scroll-top btn-hover">
      <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>